/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {

/**
 *  <h3>下拉加载控件</h3>
 *  <a href="../../ui_controls/bui.pullrefresh.html" target="_blank">demo</a>
 *  <h5>数据交互</h5>
 *  {{#crossLink "bui.pullrefresh/option"}}{{/crossLink}}: 获取设置参数 <br>
 *  {{#crossLink "bui.pullrefresh/widget"}}{{/crossLink}}: 获取依赖控件 <br>
 *  {{#crossLink "bui.pullrefresh/reverse"}}{{/crossLink}}: 还原位置,下拉请求完数据以后,需要还原位置 <br>
 *  {{#crossLink "bui.pullrefresh/fail"}}{{/crossLink}}: 请求失败以后,可以变为点击加载 <br>
 *  {{#crossLink "bui.pullrefresh/refresh"}}{{/crossLink}}: 手动刷新数据 <br>
 *  <h5>内容交互</h5>
 *  {{#crossLink "bui.pullrefresh/lock"}}{{/crossLink}}: 锁住滑动,一般用于控件冲突 <br>
 *  {{#crossLink "bui.pullrefresh/unlock"}}{{/crossLink}}: 解锁滑动,一般用于控件冲突 <br>
 *  {{#crossLink "bui.pullrefresh/setHeight"}}{{/crossLink}}: 设置内容滚动高度 <br>
 * 
 *  @namespace bui
 *  @class pullrefresh
 *  @constructor 
 *  @param {object} [option] 
 *     @param option.id {string} [ 控件的ID,需要满足固定的结构 ]
 *     @param option.handle {string} [ 操作区, .classname ]
 *     @param option.autoLoad {boolean} [ 是否第一次先执行加载 true | false ]
 *     @param option.lastUpdated {boolean} [ 是否显示更新的时间提醒 ]
 *     @param option.onRefresh {function} [ 上拉以后执行 ]
 *     @param option.refreshTips {object} 
 *          @param option.refreshTips.start {string} [ 开始加载的文本提醒 ]
 *          @param option.refreshTips.release {string} [ 下拉的文本提醒 ]
 *          @param option.refreshTips.end {string} [ 下拉高度不足提醒 ]
 *          @param option.refreshTips.fail {string} [ 下拉加载失败提醒 ]
 *          @param option.refreshTips.success {string} [ 成功提醒 ]
 * @example
 * 
 
 html:
 *
        <div id="scroll" class="bui-scroll">
            <div class="bui-scroll-head"></div>
            <div class="bui-scroll-main">
                <ul class="bui-list">
                    <li class="bui-btn">这里是循环的内容</li>
                </ul> 
            </div>
            <div class="bui-scroll-foot"></div>
        </div>

 js: 
 *   
        // 初始化
        var uiPullRefresh = bui.pullrefresh({
            id: "#scroll",
            onRefresh: getData
        })
        
        //数据请求示例
        var start = 1;
        var pagesize = 4;
        function getData (start,pagesize) {

            bui.ajax({
                url: "http://localhost/mysite/yumeng/index.php/API/Usercenter/getUserList",
                data: {
                    pageindex:start,
                    pagesize:pagesize
                }
            }).done(function(res) {

                console.log(res);

                //请求成功以后还原位置
                uiPullRefresh.reverse();

            }).fail(function (res) {
                //请求失败以后改为点击加载
                uiPullRefresh.fail();
                //请求失败以后还原位置
                uiPullRefresh.reverse();

            })
        }
 *
 */

    ui.pullrefresh = function (option) {

        //一个刷新要用到的默认结构
        var childrenTop = "."+ui.prefix("scroll-head"),
            childrenMain = "."+ui.prefix("scroll-main"),
            childrenBottom = "."+ui.prefix("scroll-foot");

        var config = {

            id: "",
            handle: "",
            childrenTop: childrenTop,
            childrenMain: childrenMain,
            // 滚动的距离要大于这个数才会触发
            distance:100,

            //默认自动加载数据
            autoLoad: true,
            lastUpdated: true,
            height: 0,

            // 底下的文本提醒
            refreshTips:{
                start:"刷新中...",
                release: "松开刷新",
                end:"继续下拉刷新",
                fail:"点击重新加载",
                success: "刷新成功"
            },
            onRefresh: null
        }

        //方法
        var module = {
            reverse: reverse,
            refresh: refresh,
            setHeight: setHeight,
            fail: fail,
            lock: lock,
            unlock: unlock,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.pullrefresh, option );
        
        var id,
            $id,
            el,
            $children,
            $childrenTop,
            $childrenMain,
            $childrenBottom,
            isLock = false,    //锁定刷新
            initTime = new Date().getTime(), //计算更新的时间
            endText,    //更新时间的文本
            loadUpFn,
            isLoad = false,//是否正在加载

            uiTouch,
            loading;

        //初始化
        init(param);

        function init (option) {
            option = option || param;
            
            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("pullrefresh id不能为空");
                return;
            }

            //option获取新参数使用
            param = module.config = option;

            el = $id[0];

            //一个scroll固有的结构
            $childrenTop = $id.children( childrenTop );
            $childrenMain = $id.children( childrenMain );
            $childrenBottom = $id.children( childrenBottom );

            //加载数据
            loadUpFn = load;

            //获取更新时间的
            endText = option.refreshTips.end ;

            //创建刷新的loading
            loading = ui.loading({
                appendTo: $childrenTop,
                width: "30",
                height: "30",
                autoClose:false,
                text: endText,
                onlyText:true,
                display:"inline",
                mask:false
            });

            //第一次是否先加载数据,还是等拉动刷新再加载
            if( option.autoLoad ){

                isLoad = true;

                loading.start({
                    text: option.refreshTips.start,
                    onlyText: false
                })
                loadUpFn();

            }else{
                //先移除加载条
                loading.stop();
            }

            //拉动加载
            bind(option);

            //设置高度才会有滚动条
            setHeight( option.height );
            
            // el.addEventListener("scroll", canLoad);

            return this;
        };

        //加载数据
        function load () {

            //更新的时间
            initTime = new Date().getTime();
            
            param.onRefresh && param.onRefresh.call(module);
        }
        //更新时间的状态提醒
        function timeTips () {

            var nowTime = new Date().getTime() ;

            var timeCount = nowTime - initTime;

            var second = 1000,
                minute = 60 * second,
                hour = 60 * minute;

            var hours = Math.floor( timeCount/hour );
            var minutes = Math.floor( timeCount/minute );
            var seconds = Math.floor( timeCount/second );
            var text;

            if ( hours <= 0 && minutes <= 0 ){
                text = "刚刚更新";
            } else if( hours <= 0 && minutes > 0){
                text = minutes + "分钟前更新";
            }else {
                text = "上次更新时间:"+ (hours < 10 ? "0"+hours: hours ) + ":"+ (minutes < 10 ? "0"+minutes: minutes ) ;
            }

            return text;

        }

        //绑定事件
        function bind (option) {
            
            if( !isLock ){

                // 如果有传loadUp 则开启下拉刷新模式
                pullToRefresh();
            }

            
        };

        //滚动条大于
        function canLoad (e) {

            var tar = e.target;
            var scrollTop = tar.scrollTop || 0;

           // 滚到底部了
            if ( tar.scrollTop > 0 ) {
                isLoad = true;
                
            }else{
                isLoad = false;
            }

        }
        //绑定刷新
        function pullToRefresh () {
            
            //Touch事件初始化
            uiTouch = ui.touch({
                id: el,
                onStart: onStart,
                onMove: onMove,
                onEnd: onEnd
            })

        }
        function onStart (e,touch) {

            endText = param.lastUpdated ? timeTips(): param.refreshTips.end;

            if ( $(window).scrollTop() <= 0 && $id.scrollTop() <= 0 && param.onRefresh && !isLoad ) {

                uiTouch.on("touchmove");
                uiTouch.on("touchend");
            }else{
                uiTouch.off("touchmove");
                uiTouch.off("touchend");
            }

        }
        function onMove(e,touch) {

            if( touch.direction == "swipeDown"){

                //移动的距离
                moveY = Math.abs(touch.y2 - touch.y1);
                //计算移动的距离
                reverse(moveY/2,false)

                if( moveY >= param.distance ){

                    //释放刷新提醒
                    loading.start({
                        text: param.refreshTips.release,
                        onlyText:true
                    });

                }else{

                    //下拉提醒
                    loading.start({
                        text: endText,
                        onlyText:true
                    });
                }

                //解决红米监听不到touchend事件
                e.preventDefault();
                e.stopPropagation();
            }

        }

        function onEnd(e,touch) {
            
            if( touch.direction == "swipeDown"){

                if( moveY >= param.distance) {

                    reverse(param.distance/2);
                    //计算移动的距离

                    loading.start({
                        text: param.refreshTips.start,
                        onlyText:false
                    });

                    isLoad = true;
                    //刷新加载下一页
                    param.onRefresh && loadUpFn();
                    
                }else{

                    reverse();
                }

                //解决红米监听不到touchend事件
                // e.preventDefault();
                e.stopPropagation();

                //清除掉这个数据
                touch = {};
            }

        }
        /**
         * 锁住拖动刷新,跟unlock配合使用
         *  @method lock
         *  @param {function} [callback] 回调
         *  @chainable
         *  @example 
         *  
            //uiPullRefresh基于顶部例子
            uiPullRefresh.lock();

         */
        function lock (callback) {
            //锁定状态
            isLock = true;
            uiTouch.off();

            //还原位置
            reverse();

            callback && callback.call(this,module);
            return this;
        }

        /**
         * 绑定拖动刷新,跟lock配合使用
         *  @method unlock
         *  @param {function} [callback] 回调
         *  @chainable
         *  @example 
         *  
            //uiPullRefresh基于顶部例子
            uiPullRefresh.unlock();

         */
        function unlock (callback) {
            
            isLock = false;

            //继续绑定
            uiTouch.on();

            callback && callback.call(this,module);

            return this;
        }
        
        /**
         * 返回原位
         *  @method reverse
         *  @param {number} [num] 数字
         *  @param {boolean} [bool] 是否使用动画 true | false
         *  @param {function} [callback] 回调
         *  @chainable
         *  @example 
         *  
            //回调里面触发 uiPullRefresh基于顶部例子
            uiPullRefresh.reverse();

         */
        function reverse (num,bool,callback) {

            bool = bool == false ? false: true;
            num = num || 0;

            isLoad = false;

            var transition = bool ? "all 300ms ease-out": "none";

            uiTouch.move(0,num+"px",transition,$childrenMain);

            if( $childrenBottom.length ){
                uiTouch.move(0,num+"px",transition,$childrenBottom);
            }

            //清除动画过渡时间,下次拉动才不会有延迟现象
            $childrenMain.one('webkitTransitionEnd',function(){
                $id.css({
                    "-webkit-transition":"none",
                    "transition":"none"
                });
                $childrenMain.css({
                    "-webkit-transition":"none",
                    "transition":"none"
                });
                $childrenBottom.css({
                    "-webkit-transition":"none",
                    "transition":"none"
                });

                //移除加载进度提醒
                if( loading ){
                
                    loading.stop();
                }

                callback && callback.call(this,module);
            });


                        
            return this;
        }

        /**
         * 请求失败改为点击加载,一般在请求的fail里面
         *  @method fail
         *  @param {object} [option] 
         *  @chainable
         *  @example 
         *  
            //uiPullRefresh基于顶部例子
            uiPullRefresh.fail();

         */
        function fail () {

            isFail = true;
            loading.start({
                text: param.refreshTips.fail,
                onlyText:true,
                callback:function (argument) {
                    //点击重新加载
                    loadUpFn()
                }
            });

        }

        /**
         * 手动刷新数据
         *  @method refresh
         *  @chainable
         *  @example 
         *  
            //uiPullRefresh基于顶部例子
            uiPullRefresh.refresh();

         */
        function refresh () {
            param.onRefresh && loadUpFn();
            //重新绑定拖拽
            unlock();
        }

        /**
         * 设置滚动的高度,常用于$(window).resize(fun)
         *  @method setHeight
         *  @param {number|string} [height] 设置的高度
         *  @chainable
         *  @example 
         *  
            //uiPullRefresh基于顶部例子
            uiPullRefresh.setHeight();

         */
        function setHeight (height) {
            height = height ? parseFloat(height): $(window).height() -  ($("header").height() || 0) - ($("footer").height() || 0) - ( el&&el.offsetTop || 0 ) ;
            //设置高度才能滚动
            $id.height(height);
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 loading ]
         *  @example 
            
            //获取依赖控件
            var uiPullRefreshWidget = uiPullRefresh.widget();
            
                
         */
        function widget(name) {
            var control = { loading:loading, touch: uiTouch };
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiPullRefresh.option();

            //获取某个参数
            var id = uiPullRefresh.option( "id" );

            //修改一个参数
            uiPullRefresh.option( "lastUpdated",false );

            //修改多个参数
            uiPullRefresh.option( {"lastUpdated":false} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;

    };

    return ui;

})( bui || {}, libs );
